import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="p-8">
          <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-6">
            <p className="text-red-400 font-bold mb-2">페이지 렌더링 오류</p>
            <pre className="text-red-300 text-xs whitespace-pre-wrap">{this.state.error.message}</pre>
            <pre className="text-gray-500 text-xs mt-2 whitespace-pre-wrap">{this.state.error.stack}</pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
